<pre class="m-0 bg-white p-4 font-mono text-sm text-gray-800">{{
  { version: version } | json
}}</pre>
